import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Header.css';

const Header = () => {
    const { t, i18n } = useTranslation();
    const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
    const [showAboutDropdown, setShowAboutDropdown] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
        setShowLanguageDropdown(false);
        setMenuOpen(false);
    };

    const toggleDropdown = (e, dropdownType) => {
        e.preventDefault();
        if (dropdownType === 'language') {
            setShowLanguageDropdown(!showLanguageDropdown);
            setShowAboutDropdown(false);
        } else {
            setShowAboutDropdown(!showAboutDropdown);
            setShowLanguageDropdown(false);
        }
    };

    const closeMenu = () => setMenuOpen(false);

    return (
        <header className="header">
            <div className="logo">
                <Link to="/" onClick={closeMenu}>
                    <img src="/images/cflogobordas.png" alt={t('logoAlt')} className="logo-image" />
                </Link>
            </div>

            <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </div>

            <nav className={`nav-menu ${menuOpen ? 'open' : ''}`}>
                <ul>
                    <li className="nav-item">
                        <Link to="/cliente/cadastro" onClick={closeMenu}>
                            {t('Cadastrar') || 'Cadastro'}
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link to="/dono-da-carga" onClick={closeMenu}>{t('donoDaCarga')}</Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/motorista" onClick={closeMenu}>{t('motorista')}</Link>
                    </li>

                    {/* Dropdown Sobre (agora com Cidades dentro) */}
                    <li
                        className="dropdown nav-item"
                        onMouseEnter={() => window.innerWidth > 768 && setShowAboutDropdown(true)}
                        onMouseLeave={() => window.innerWidth > 768 && setShowAboutDropdown(false)}
                    >
                        <span
                            onClick={(e) => {
                                if (window.innerWidth <= 768) {
                                    toggleDropdown(e, 'about');
                                }
                            }}
                            className="dropdown-trigger"
                        >
                            Sobre Carga Fácil
                        </span>
                        <div className={`dropdown-container about-dropdown ${showAboutDropdown ? 'visible' : ''}`}>
                            <ul className="dropdown-menu">
                                <li className="dropdown-item">
                                    <Link to="/sobre" onClick={closeMenu}>{t('sobreCargaFacil')}</Link>
                                </li>
                                <li className="dropdown-item">
                                    <Link to="/cidades" onClick={closeMenu}>{t('cidades')}</Link>
                                </li>
                                <li className="dropdown-item">
                                    <Link to="/carreiras" onClick={closeMenu}>{t('carreiras')}</Link>
                                </li>
                                <li className="dropdown-item">
                                    <Link to="/parceiros" onClick={closeMenu}>{t('parceiros')}</Link>
                                </li>
                            </ul>
                        </div>
                    </li>

                    {/* Dropdown Idiomas */}
                    <li
                        className="language-selector nav-item"
                        onMouseEnter={() => window.innerWidth > 768 && setShowLanguageDropdown(true)}
                        onMouseLeave={() => window.innerWidth > 768 && setShowLanguageDropdown(false)}
                    >
                        <div
                            className="language-current"
                            onClick={(e) => {
                                if (window.innerWidth <= 768) {
                                    toggleDropdown(e, 'language');
                                }
                            }}
                        >
                            <span role="img" aria-label="Globo">🌐</span> {i18n.language.toUpperCase()}
                        </div>
                        <div className={`dropdown-container language-dropdown-container ${showLanguageDropdown ? 'visible' : ''}`}>
                            <ul className="language-dropdown">
                                <li className="dropdown-item" onClick={() => { changeLanguage('pt'); closeMenu(); }}>Português</li>
                                <li className="dropdown-item" onClick={() => { changeLanguage('en'); closeMenu(); }}>English</li>
                                <li className="dropdown-item" onClick={() => { changeLanguage('it'); closeMenu(); }}>Italiano</li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;